import dateToUTC from "./dateToUTC";
import getStartOfMonth from "./getStartOfMonth";

const getStartOfMonthUTC = (month: number, year: number) =>
  dateToUTC(getStartOfMonth(month, year));

export default getStartOfMonthUTC;
